module.exports = __WEBPACK_EXTERNAL_MODULE_81__;


//////////////////
// WEBPACK FOOTER
// external {"root":"numbro","commonjs2":"numbro","commonjs":"numbro","amd":"numbro"}
// module id = 81
// module chunks = 0